import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import DefaultStorefrontLayout from "components/storefront/StorefrontLayout";

const StorefrontLayoutContext = createContext(DefaultStorefrontLayout);

export function StorefrontLayoutProvider({ layout, children }) {
  const Layout = layout || DefaultStorefrontLayout;
  return (
    <StorefrontLayoutContext.Provider value={Layout}>
      {children}
    </StorefrontLayoutContext.Provider>
  );
}

StorefrontLayoutProvider.propTypes = {
  layout: PropTypes.elementType,
  children: PropTypes.node.isRequired,
};

StorefrontLayoutProvider.defaultProps = {
  layout: null,
};

export function useResolvedStorefrontLayout() {
  return useContext(StorefrontLayoutContext);
}
